
import React, { useEffect, useState } from 'react';
import { useDispatch } from "react-redux";
import { addCart } from "../redux/action";
import { Link, useParams, useNavigate } from "react-router-dom";
import toast from 'react-hot-toast';
import axios from 'axios';
import { CartUpdate } from "../services/CartUpdate";
import { FavoriteBorderOutlined, KeyboardArrowRight } from '@mui/icons-material';
import { Url } from '../services/Constants';
import { useLocation } from 'react-router-dom';
import { GetUserRole } from '../services/UserRole';
import { setHeader } from '../services/Headers'

export default function SellerOrderTiles({order}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [usertype, setUserType] = useState(false);
  const [products, setProducts] = useState([])
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const categoryId = query.get('category_id');
  const navigate = useNavigate();
  const [favoriteProducts, setFavoriteProducts] = useState([]);
  const userRole = GetUserRole();
  const dispatch = useDispatch();


 


  return (
    <div className="container">
      {/* Product Grid */}
      <div className="">
          <div className="feed-container rounded-md shadow-lg border-2 mt-4 object-cover">
            <div className="feed-top group relative flex">
              <img
                src={order.product_images?.[0]?.image || "placeholder.jpg"}
                alt={order.product_name}
                className="w-full h-52 rounded-t-lg"
              />
            </div>
            <div className="bottom pl-3 my-3">
                <div className="title flex justify-between">
                <span className="text-xl truncate w-1/2 text-amber-950 font-bold">
                  {order.product_name}
              </span>
              <div className=" hover:underline flex text-xs cursor-pointer items-center max-xl:text-[10px]">
                <span className="k ">Order Details</span>
                <KeyboardArrowRight fontSize='medium' className=''/>  
              </div>
                </div>
                <div className="orderid my-3 max-xl:my-1">
                    <span className="k text-amber-950">{order.order_number}</span>
                </div>
                <div className="dateAndStatus flex justify-between cursor-default">
                    <span className="k text-sm mb-1">{new Date(order.order_created_at).toLocaleDateString()}</span>
                    </div>
                    <div className="right mr-2 text-end">
                    <span className="k text-amber-950 border px-3 py-1 rounded-sm max-xl:text-xs ">{order.order_status}</span>
                    </div>
              
            </div>
          </div>
      </div>
    </div>
  );
}
